import axios from 'axios'
import miniToastr from 'mini-toastr'
import configAll from '../../../../config/index.cjs'
import {endOfDay, format, startOfDay} from "date-fns";

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']
const API_URL = config.urlServer
const ADD_BULK_URL = `${API_URL}api/per/everydayanswers/one`
const GET_TODAY_URL = `${API_URL}api/per/everydayanswers/one`
const GET_QUEST_URL = `${API_URL}api/per/everydayquestions/`

export default {
  namespaced: true,
  state: {
    answ: [],
    questions: []
  },
  mutations: {
    getToday (state, items) {
      // eslint-disable-next-line
      state.answ = items;
    },
    addBulk (state, items) {
      // eslint-disable-next-line
      state.answ = items;
    },
    setQuestions (state, items) {
      // eslint-disable-next-line
      state.questions = items;
    },
    edit(state, item) {
      state.answ = [item];
    }
  },
  actions: {
    getToday ({ commit }, obj) {
      const startDay = format(startOfDay(new Date(obj.date1)), 'yyyy-MM-dd HH:mm:ss').toString()
      const endDay = format(endOfDay(new Date(obj.date1)), 'yyyy-MM-dd HH:mm:ss').toString()

      // eslint-disable-next-line
      // GET_TODAY_URL, { params: { aa: 2, bb: 3 } } not working
      axios.get(`${GET_TODAY_URL}?fromDate=${encodeURI(startDay)}&toDate=${encodeURI(endDay)}`)
        .then((response) => {
          commit('getToday', response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Answers failed!', 1500);
        })
    },
    addBulk ({ commit }, payload) {
      axios.post(ADD_BULK_URL, payload)
        .then((response) => {
          commit('addBulk', response.data)
          miniToastr.success('Added Answer!', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Add Answer failed!', 1500)
        })
    },
    // send request to login url and save returned jwt
    // eslint-disable-next-line
    edit ({ commit }, payload) {
      axios.put(`${API_URL}api/per/everydayanswers`, payload, { params: { id: payload.id } })
        .then(() => {
          commit('edit', payload)
          miniToastr.success('Edited Answer!', '', 1500)
          // context.$scrollTo('.fl-msg', 1000, options);
          //
          // context.showSuccess({
          //   message: 'Edited Answer',
          //   beforeDestroy() {
          //     setTimeout(() => {
          //       context.$modal.hide('edit-daily-answers');
          //     }, 1500);
          //   },
          // });
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Answer failed!', 1500)
        })
    },
    getQuestions ({ commit }) {
      axios.get(GET_QUEST_URL)
        .then((response) => {
          commit('setQuestions', response.data)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Get Questions failed!', 1500)
        })
    }
  }
}
